import Seo from 'src/components/Seo';
import '../home/tokens.css';

import SchoolNav from './_nav/index';
import Hero from './01.hero/index';
import Tasks from './02.tasks/index';
import Shift from './03.shift/index';
import Flow from './04.flow/index';
import Reduce from './05.reduce/index';
import Students from './06.students/index';
import Numbers from './07.numbers/index';
import Support from './08.support/index';
import Steps from './09.steps/index';
import Faq from './10.faq/index';
import Cta from './11.cta/index';
import SchoolFooter from './_footer/index';

/*
 * 美容・理容専門学校の就職担当者向け LP。
 * サロン向け LP（/company・src/pages/home）とはターゲット・導入理由が異なるため、
 * デザイントークン（../home/tokens.css）と一部の共通 UI（_ui/sectionTitle・_placeholder）
 * だけを流用し、文言・構成・訴求はすべて学校の求人票管理業務から作り直している。
 *
 * 実プロダクト画面が入る箇所は _placeholder コンポーネント＋ {/* TODO *\/} コメントで明示し、
 * 後からスクリーンショットへ差し替える前提。
 */

const seoProps = {
  // TODO: 集客方針が固まるまで noindex にする場合は Seo に noindex を渡す
  title: '美容・理容専門学校向け | memorii works（求人票管理）',
  description:
    '毎年届く大量の求人票を、スキャン・ファイリングせずに管理。memorii works なら、サロンの求人票が最初からデジタルで学校の管理画面に届き、そのまま学生へ届けられます。',
  canonical: 'https://memorii-works.com/school',
};

const SchoolLp = () => {
  return (
    <Seo {...seoProps}>
      <SchoolNav />
      <main>
        <Hero />
        <Tasks />
        <Shift />
        <Flow />
        <Reduce />
        <Students />
        <Numbers />
        <Support />
        <Steps />
        <Faq />
        <Cta />
      </main>
      <SchoolFooter />
    </Seo>
  );
};

export default SchoolLp;
